angular
	.module 'App.Repository'
	.factory 'MakeSecretRepository', ['BaseRepository', (BaseRepository) ->
		class MakeSecretRepository extends BaseRepository
			@resource = '/make_secret'
			@isRestricted = true

		return new MakeSecretRepository
	]
